<!--
 * @Author: WGL
 * @Date: 2023-10-31 10:15:08
 * @LastEditors: WGL 958897276@qq.com
 * @LastEditTime: 2025-12-04 14:54:55
 * @Description: 
-->
<template>
  <el-tooltip
    content="使用文档"
    effect="dark"
    :persistent="false"
    placement="bottom"
  >
    <a :href="shopUrl" target="_blank">
      <vab-icon icon="book-open-line" @click="click" />
    </a>
  </el-tooltip>
</template>

<script>
  import { computed, defineComponent } from 'vue'

  export default defineComponent({
    name: 'VabDocument',
    setup() {
      const shopUrl = computed(() => {
        const webOrigin = window.location.origin
        return `${webOrigin}/#/document`
      })
      const click = () => {}

      return {
        click,
        shopUrl,
      }
    },
  })
</script>
